import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import Expire from './Expire';
import warning from "react-redux/lib/utils/warning";

require.ensure([], () => {
    require('./NotificationsBar.less');
    require('./Material-Design-Iconic.less');
});

class NotificationsBar extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    // OTHER METHODS

    convertActionToText = (action) => {
        let text = action.toLowerCase().
                    replace(/_/g, ' ').
                    replace(/\bpmo\b/g, 'PMO').
                    replace(/\blm\b/g, 'LM').
                    replace(/\bcm\b/g, 'CM').
                    replace(/\bpm\b/g, 'PM');
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    // RENDER METHOD

    render = () => {
        return (
            <div>
                { this.props.error.map((error, i) => {
                    return (
                        <Expire key={i} id={i} delay={1500}>
                            <div className="alert alert-danger panel panel-body panel-content notification-popup" style={{"top": 45*i + 7 + "px"}}>
                                <h4>
                                    <i style={{"color": "#CC2200"}} className="md-error"/>
                                        &nbsp;Error during action: { this.convertActionToText(error) }
                                </h4>
                            </div>
                        </Expire>
                    );
                  })
                }
                { this.props.success.map((success, i) => {
                    return (
                         <Expire key={i} id={i} delay={1500}>
                            <div className="alert alert-success panel panel-body panel-content notification-popup" style={{"top": "7px"}}>
                                <h4>
                                    <i style={{"color": "#00CC22"}} className="md-done"/>
                                        &nbsp;Action successfully executed: { this.convertActionToText(success) }
                                </h4>
                            </div>
                        </Expire>
                    );
                  })
                }
              { this.props.warning.map((warning, i) => {
                return (
                    <Expire key={i} id={i} delay={1500}>
                      <div className="alert alert-danger panel panel-body panel-content notification-popup" style={{"top": 45*i + 7 + "px"}}>
                        <h4>
                          <i style={{"color": "#CC2200"}} className="md-error"/>
                         &nbsp;Warning: { this.convertActionToText(warning) }
                       </h4>
                     </div>
                    </Expire>
                );
              })
              }
            </div>
        );
    }
}

NotificationsBar.propTypes = {
    children: PropTypes.element,
    error: PropTypes.array,
    success: PropTypes.array,
    warning: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        error: state.events.error,
        success: state.events.success,
        warning: state.events.warning
    };
};


export default connect(
    mapStateToProps
)(NotificationsBar);



/** WEBPACK FOOTER **
 ** ./src/app/components/NotificationsBar.js
 **/